import { render } from "./period_bateing_history.vue?vue&type=template&id=42f4a59e"
import script from "./period_bateing_history.vue?vue&type=script&lang=js"
export * from "./period_bateing_history.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__